var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { IconBaseSvg } from "../icon-base";
var SyncIcon = function (props) { return (React.createElement(IconBaseSvg, __assign({}, props, { viewBox: "0 0 24 24" }),
    React.createElement("g", { id: "Icon/ic_sync", strokeWidth: "0" },
        React.createElement("path", { d: "M5347.31-4277.878a.5.5,0,0,1-.312-.454v-1.79a8,8,0,0,1-8-8,7.838,7.838,0,0,1,.568-2.95,1,1,0,0,1,.729-.614,1,1,0,0,1,.913.274.963.963,0,0,1,.229,1.041,5.851,5.851,0,0,0-.441,2.25,6,6,0,0,0,6,6v-1.79a.5.5,0,0,1,.305-.463.5.5,0,0,1,.545.1l2.79,2.79a.5.5,0,0,1,.147.354.5.5,0,0,1-.146.355l-2.791,2.79a.5.5,0,0,1-.35.143A.491.491,0,0,1,5347.31-4277.878Zm5.078-7.548a.963.963,0,0,1-.23-1.04,5.8,5.8,0,0,0,.44-2.25,6,6,0,0,0-6-6v1.79a.507.507,0,0,1-.311.464.5.5,0,0,1-.549-.1l-2.79-2.791a.5.5,0,0,1-.147-.355.5.5,0,0,1,.147-.354l2.8-2.791a.5.5,0,0,1,.542-.1.5.5,0,0,1,.309.456v1.791a8,8,0,0,1,8,8,7.818,7.818,0,0,1-.57,2.95,1,1,0,0,1-.729.614,1.026,1.026,0,0,1-.2.021,1,1,0,0,1-.711-.307Z", transform: "translate(-5338.999 4298.991)" })))); };
export default SyncIcon;
//# sourceMappingURL=SyncIcon.js.map